import { loadXLSX } from '@ubeya/shared/utils/spreadsheetLibraries';

export const getColumnHeadersFromFile = (data, columnsOptions) => {
  const formattedColumnOptions = columnsOptions.map((option) => ({
    ...option,
    label: option.label.toUpperCase().replace(/\s/g, '')
  }));
  const fileHeaders = Object.keys(data[0]).map((header) => String(header).toUpperCase().replace(/\s/g, ''));
  const matchingColumns = {};

  fileHeaders.forEach((header, index) => {
    const headerIndex = formattedColumnOptions.findIndex(({ label }) => label === header);

    if (headerIndex !== -1) {
      matchingColumns[index] = formattedColumnOptions[headerIndex].value;
    }
  });

  return matchingColumns;
};

export const createHandleDrop = (onChange, setLoading, options = {}) => {
  const { processWorksheet, processData, onDataReady } = options;

  return (file) => {
    setLoading(true);
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = async (e) => {
      let XLSX;
      try {
        XLSX = await loadXLSX();
      } catch (error) {
        setLoading(false);
        return;
      }
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true, cellDates: false });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      // Process worksheet if processor is provided
      if (processWorksheet) {
        processWorksheet(ws);
      }

      let data = XLSX.utils.sheet_to_json(ws, { defval: '' });

      // Process data if processor is provided
      if (processData) {
        data = processData(data);
      } else {
        // Default: map data to clean objects
        data = data.map(({ ...rest }) => ({ ...rest }));
      }

      // Call onDataReady if provided
      if (onDataReady) {
        onDataReady(data);
      }

      onChange(data);
      setLoading(false);
      document.getElementById('next-step').click();
    };

    if (rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  };
};
